import React, { FC } from 'react';
import { ITranslate } from 'core/interface/translate';
import Activation from '../Index';
import Button from 'components/Button/Index';

import './Index.scss';

const ReadyToStart: FC<ITranslate> = ({ t }): JSX.Element => {
  return (
    <Activation title={t('Ready to get started?')} currentStep={5}>
      <div className="starter">
        <p className="starter__text">{t('activation_ready_to_start_text')}</p>
        <div className="buttons">
          <Button className="btn back" t={t} title="back" />
          <Button className="btn next" t={t} title="go_to_profile" />
        </div>
      </div>
    </Activation>
  );
};

export default ReadyToStart;
